// Comms final pass (#759 follow-up): which group header a conversation sits under when "Group by account" is on.
//   account      the conversation's own CRM account (an account named by a phone number shows its person, else the number formatted)
//   contact's    no account on the conversation, but the CRM contact matched by its phone / email belongs to one: that account
//   No company   a CRM contact matched, with no account at all
//   Not in CRM   nobody in the CRM has this number or email (the only group that offers "Add to CRM")
import { formatPhone } from './phone';

export const NOT_IN_CRM_LABEL = 'Not in CRM';
export const NO_COMPANY_LABEL = 'No company';

const PHONE_LIKE = /^\+?[\d\s().-]{7,}$/;

function text(value) {
    return typeof value === 'string' ? value.trim() : '';
}

/** True for an account "name" that is really a phone number ("+14043908611", "(404) 390-8611"). */
export function looksLikePhoneName(value) {
    const name = text(value);
    return Boolean(name) && PHONE_LIKE.test(name) && name.replace(/\D/g, '').length >= 7;
}

/** How an account name reads in a header: a phone-number name gives way to the person's name, else is formatted. */
export function accountHeaderLabel(accountName, personName = '') {
    const name = text(accountName);
    if (!looksLikePhoneName(name)) return name;
    return text(personName) || formatPhone(name) || name;
}

export function threadGroupFor(thread = {}) {
    const accountName = text(thread.accountName);
    const person = text(thread.contactName) || (looksLikePhoneName(thread.name) ? '' : text(thread.name));
    if (thread.accountId || (accountName && accountName !== 'No account')) {
        return {
            key: `account:${thread.accountId || accountName}`,
            label: accountHeaderLabel(accountName, person) || accountName,
            kind: 'account',
        };
    }
    if (thread.contactId) {
        if (thread.contactAccountId) {
            return {
                key: `account:${thread.contactAccountId}`,
                label: accountHeaderLabel(thread.contactAccountName, person) || text(thread.contactAccountName),
                kind: 'account',
            };
        }
        return { key: '\u0000no-company', label: NO_COMPANY_LABEL, kind: 'no-company' };
    }
    return { key: '\u0000not-in-crm', label: NOT_IN_CRM_LABEL, kind: 'not-in-crm' };
}

/** Groups in first-seen order (the list is already sorted). */
export function groupThreadsForList(threads = []) {
    const groups = [];
    const byKey = new Map();
    (Array.isArray(threads) ? threads : []).forEach((thread) => {
        const group = threadGroupFor(thread);
        let entry = byKey.get(group.key);
        if (!entry) {
            entry = { key: group.key, accountName: group.label, kind: group.kind, notInCrm: group.kind === 'not-in-crm', threads: [] };
            byKey.set(group.key, entry);
            groups.push(entry);
        }
        entry.threads.push(thread);
    });
    return groups;
}
